import { useCallback } from 'react';
import { Flex, RemoteVideo, Image } from '../../2022-component-library';
import { useTestContext } from '../../context/testContext';
import RotatingWheelImgBlack from '../../assets/img/ros_ui_fixationpoint.png';
import RotatingWheelImgWhite from '../../assets/img/ros_ui_fixationpoint_black.png';

export const FixationTargetVF2 = ({ coords, setupData: { fixationType, contrastType } }) => {
  const {
    testData: {
      visualFieldSettings: { fixationTargetDimensions },
    },
  } = useTestContext();

  const RotatingWheel = useCallback(() => {
    const rotatingWheelImg = contrastType === 'whiteOnBlack' ? RotatingWheelImgWhite : RotatingWheelImgBlack;
    return <Image className='rotatingWheelFixation' src={rotatingWheelImg} />;
  }, [contrastType]);

  return (
    <Flex
      height={`${fixationTargetDimensions.height}px`}
      width={`${fixationTargetDimensions.width}px`}
      style={{ position: 'absolute', top: `${coords?.y || 0}px`, left: `${coords?.x || 0}px`, transition: 'all 1900ms ease' }}
    >
      {fixationType?.type === 'thumbnailOperator' ? (
        <RemoteVideo />
      ) : (
        <>
          <Flex style={{ position: 'absolute', zIndex: -1 }}>
            <RemoteVideo />
          </Flex>
          <RotatingWheel />
        </>
      )}
    </Flex>
  );
};
